// import React, { useState } from 'react'
import './Contact.css'
import './ProcessSteps.css'
import Navbar from './Navbar'
import Foorter from './Footer'
import ContactForm from './ContactForm'
import FAQ from './FAQ'

const Contact = () => {
  return (
    <>
      <Navbar />
      {/* dark hero banner — matches home page style */}
      <div className="contact-hero">
        <div className="section-tag">
          <hr />
          <span>.get in touch</span>
        </div>
        <h1 className="contact-hero-title">Tell us what you're building.</h1>
        <p className="contact-hero-sub">
          Send a brief, ping on WhatsApp, or just say hello — I'll come back with next steps within one business day.
        </p>
      </div>

      {/* white body section */}
      <section className="contact-page">
        <div className="contact-page-grid">
          {/* ---------- left: direct info cards ---------- */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">✉</div>
              <div>
                <span className="info-label">EMAIL</span>
                <a href="mailto:askdevelopers8@gmail.com">askdevelopers8@gmail.com</a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">☎</div>
              <div>
                <span className="info-label">PHONE / WHATSAPP</span>
                <a href="https://wa.me/923114386437">+92 311 4386437</a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📍</div>
              <div>
                <span className="info-label">LOCATION</span>
                <p>Based anywhere · Available remotely</p>
              </div>
            </div>

            <div className="social-links">
              <a href="#" target="_blank" rel="noreferrer">LinkedIn</a>
              <a href="#" target="_blank" rel="noreferrer">GitHub</a>
              <a href="#" target="_blank" rel="noreferrer">Twitter / X</a>
            </div>
          </div>

          {/* ---------- right: dark floating form ---------- */}
          <ContactForm />
        </div>
      </section>

      {/* ---------- how it works ---------- */}
      <section className="process-section">
        <h2 className="process-title">How It Works</h2>
        <div className="process-grid">
          <div className="process-step">
            <div className="process-num">01</div>
            <h4>Send a Message</h4>
            <p>Fill out the form or drop a WhatsApp message with a bit about your project.</p>
          </div>
          <div className="process-step">
            <div className="process-num">02</div>
            <h4>Quick Call</h4>
            <p>We hop on a short call to talk through goals, scope, and timeline.</p>
          </div>
          <div className="process-step">
            <div className="process-num">03</div>
            <h4>Proposal</h4>
            <p>You get a clear plan — timeline, deliverables, and cost — no surprises.</p>
          </div>
          <div className="process-step">
            <div className="process-num">04</div>
            <h4>Build & Deliver</h4>
            <p>I build, you get regular updates, and we launch together.</p>
          </div>
        </div>
      </section>

      {/* ---------- faq ---------- */}
      <FAQ />

      <Foorter />
    </>
  )
}

export default Contact